// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// FORM_MUTATION_META is a plain constant, unaffected — reference copy is
// fine. The rest are real function declarations, not reference copies —
// see hooks/useAuth.ts.
import * as _formErrorHandlerModule from "@livingsyncs/ui";

export { FORM_MUTATION_META } from "@livingsyncs/ui";

export function extractApiError(
  ...args: Parameters<typeof _formErrorHandlerModule.extractApiError>
) {
  return _formErrorHandlerModule.extractApiError(...args);
}
export function extractValidationDetails(err: unknown) {
  return _formErrorHandlerModule.extractValidationDetails(err);
}
export function scrollToFirstError() {
  return _formErrorHandlerModule.scrollToFirstError();
}
export function handleFormValidationErrors(
  ...args: Parameters<typeof _formErrorHandlerModule.handleFormValidationErrors>
) {
  return _formErrorHandlerModule.handleFormValidationErrors(...args);
}
export function handleGenericFormError(
  ...args: Parameters<typeof _formErrorHandlerModule.handleGenericFormError>
) {
  return _formErrorHandlerModule.handleGenericFormError(...args);
}
export function handleFormErrors(
  ...args: Parameters<typeof _formErrorHandlerModule.handleFormErrors>
) {
  return _formErrorHandlerModule.handleFormErrors(...args);
}
